import React from 'react';
import { Bot } from 'lucide-react';
import ToolUnitPicker from '@/components/ToolUnitPicker';

export default function AIGenerateIndex() {
  return (
    <ToolUnitPicker
      title="AI Generate"
      subtitle="Open a unit and use the AI tools to generate primary sources, vocabulary, lecture notes, lesson plans, and more."
      icon={Bot}
      accent="bg-purple-700"
      buildTargetPath={(unit) => `/unit/${unit.id}`}
      ctaLabel="Generate Content"
    />
  );
}
